import { render, staticRenderFns } from "./setMealList.vue?vue&type=template&id=2e76cf20&scoped=true&"
import script from "./setMealList.vue?vue&type=script&lang=js&"
export * from "./setMealList.vue?vue&type=script&lang=js&"
import style0 from "./setMealList.vue?vue&type=style&index=0&id=2e76cf20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e76cf20",
  null
  
)

export default component.exports